import * as RSwitch from '@radix-ui/react-switch';
import { useId, type ReactNode } from 'react';

export function Switch({
  label,
  checked,
  onCheckedChange,
  disabled,
  hint,
}: {
  label: ReactNode;
  checked: boolean;
  onCheckedChange: (v: boolean) => void;
  disabled?: boolean;
  hint?: ReactNode;
}) {
  const id = useId();
  return (
    <div className="flex items-start justify-between gap-md">
      <label htmlFor={id} className="flex flex-col gap-[2px]">
        <span className="text-small font-medium text-ink-graphite">{label}</span>
        {hint && <span className="text-small text-ink-mute">{hint}</span>}
      </label>
      <RSwitch.Root
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="relative h-[22px] w-[40px] shrink-0 rounded-pill bg-hairline-strong transition-colors duration-almanac ease-almanac focus-visible:shadow-focus data-[state=checked]:bg-accent-blue disabled:opacity-40"
      >
        <RSwitch.Thumb className="block h-[18px] w-[18px] translate-x-[2px] rounded-pill bg-canvas-paper transition-transform duration-almanac ease-almanac data-[state=checked]:translate-x-[20px] rtl:data-[state=checked]:-translate-x-[20px]" />
      </RSwitch.Root>
    </div>
  );
}
